
/**
 * Created by VsCode.
 * @author Evan Chan
 * @date 2018/8/7
 */

import axios from 'axios'
import Qs from 'qs'
import { config } from '../config'

// const env = process.env.NODE_ENV || 'development'
const hostName = window.location.hostname
let env = hostName.indexOf('.com') > -1 ? hostName.split('.')[0] : 'development'
let instance = axios.create({
  method: 'post',
  withCredentials: true,
  timeout: 10000,
  headers: Object.assign({
    'Accept': '*',
    'Content-Type': 'application/json'
  }, config.httpHeaders || {})
  // transformRequest: [function (data) {
  //   data = Qs.stringify(data)
  //   return data
  // }]
})

instance.interceptors.request.use(req => {
  return req
}, err => {
  return Promise.reject(err)
})

instance.interceptors.response.use(res => {
  // tools.isRequest = false
  return res
}, err => {
  return Promise.reject(err)
})

const normalHandler = (resolve, res, option) => {
  let r = res.data
  if (r && typeof r === 'string') { // 处理安卓4.4.4以下 返回数据
    r = JSON.parse(r)
  }
  if (r) {
    if (r.status == 1) {
      resolve(r)
    } else {
      const c = r.code
    }
  } else {
    res && resolve({
      status: 0,
      code: 500,
      error: '未知错误'
    })
  }
}

const errorHandler = (reject, err) => {
  console.error(err)
  reject({
    status: 0,
    code: 500,
    error: err.message || err
  })
}

export default async (url = '', params = {}, option = {}) => {
  if (!url) {
    return Promise.reject(new Error(`params 'url' not exist！`))
  }
  let method = option.method || 'post'
  // prefixName 用于请求分发，非必要
  let prefixName = option.prefixName || 'default'
  // 判断为非全路径，则补全url前缀
  if (url.indexOf('http') !== 0) {
    let prefix = config.apiPath[prefixName]
    url = prefix[process.env.NODE_ENV] + url
    // if (typeof prefix === 'string') {
    //   url = prefix + url
    // } else if (typeof prefix === 'object') {
    //   url = prefix[env] + url
    // }
  }
  if (option.headers && option.headers['Content-Type'] === 'application/json') {
    instance.defaults.transformRequest = [function (data) {
      return JSON.stringify(data)
    }]
  } else {
    instance.defaults.transformRequest = [function (data) {
      data = Qs.stringify(data)
      return data
    }]
  }
  switch (method) {
    case 'get':
      return new Promise((resolve, reject) => {
        instance.get(url, params, option).then(res => {
          normalHandler(resolve, res, option)
        }).catch(err => {
          errorHandler(reject, err)
        })
      })
    case 'post':
    case 'put':
    case 'patch':
      return new Promise((resolve, reject) => {
        instance.post(url, params, option).then(res => {
          normalHandler(resolve, res, option)
        }).catch(err => {
          errorHandler(reject, err)
        })
      })
    default:
      return Promise.reject(new Error(`unknown request method '${method}'`))
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js